export default "__VITE_ASSET__Dle7zlli__"